import { getArtifactChipDisplay } from 'breeze-artifacts-sdk/chip/artifactChipDisplay';
import ManagedArtifactChip from 'breeze-artifacts-sdk/chip/ManagedArtifactChip';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultArtifactChip = ({
  artifact,
  onArtifactClick,
  disableArtifacts,
  disabledTooltip
}) => {
  const {
    icon,
    translatedLabel
  } = getArtifactChipDisplay(artifact.artifactType);
  return /*#__PURE__*/_jsx(ManagedArtifactChip, {
    artifact: artifact,
    onArtifactClick: onArtifactClick,
    disableArtifacts: disableArtifacts,
    icon: icon,
    translatedLabel: translatedLabel,
    disabledTooltip: disabledTooltip
  });
};
export default DefaultArtifactChip;